function handleCollapsedMenu() {
  $(".navbar-toggler").on("click", function () {
    if ($(window).width() < 1024) {
      const bannerHeight = $(".banner-top-page").height();
      const navbarHeight = $(".js-navbar-height").height();

      const bannerAndMenuHeight = bannerHeight
        ? bannerHeight + navbarHeight
        : navbarHeight;

      $(".navbar-nav").css("top", `${bannerAndMenuHeight}px`);
    }
  });
}

export default handleCollapsedMenu;
